import "./../../styles/Reviews.css";

const ReviewStats = ({ stats }) => {
    return (
        <div className="review-stats">

            <div className="review-card">
                <h3>Total Reviews</h3>
                <h2>{stats.total || 0}</h2>
            </div>

            <div className="review-card">
                <h3>Average Rating</h3>
                <h2>{stats.averageRating || 0} ⭐</h2>
            </div>

            <div className="review-card">
                <h3>Approved</h3>
                <h2>{stats.approved || 0}</h2>
            </div>

            <div className="review-card">
                <h3>Pending</h3>
                <h2>{stats.pending || 0}</h2>
            </div>

            <div className="review-card">
                <h3>Hidden</h3>
                <h2>{stats.hidden || 0}</h2>
            </div>

            <div className="review-card">
                <h3>Reported</h3>
                <h2>{stats.reported || 0}</h2>
            </div>

        </div>
    );
};

export default ReviewStats;